import { render, staticRenderFns } from "./drilled-section.vue?vue&type=template&id=6e4205ac&scoped=true"
import script from "./drilled-section.vue?vue&type=script&lang=js"
export * from "./drilled-section.vue?vue&type=script&lang=js"
import style0 from "./drilled-section.vue?vue&type=style&index=0&id=6e4205ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4205ac",
  null
  
)

export default component.exports